var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 12 12",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(0,0,0,0.14901960784313725)",
    d: "M4 3h4M3 4h2m2 0h2M3 5h1m4 0h1M3 6h1m4 0h1M3 7h2m2 0h2M4 8h4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ffe416",
    d: "M5 4h2M4 5h1m1 0h1M4 6h3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ffed64",
    d: "M5 5h1m1 0h1M7 6h1M5 7h2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.1f1f7c8b9912309c53a0ee80fa8d603d.svg";
export { ForwardRef as ReactComponent };